export default "skymp5-front/ee4d74a27f0748d152ab430f5f154141.png";